---
fr:
  asset_comments:
    create_title: Créer un nouveau commentaire
    overlap_current_month: Commentaire en chevauchement pour le mois en cours de l'année en cours
    overlap_current_quarter: Commentaire en chevauchement pour le trimestre en cours de l'année en cours
    overlap_current_year: Commentaire en chevauchement pour l'année en cours
    title: Commentaire actif
